import auth from "./auth/reducer";
import inquiries from "./inquiries/reducer";

export default { auth, inquiries };
